import { useTranslator } from '@picsart/rc/services/localization';

interface ErrorFallbackProps {
  onReset: () => void;
}

export function ErrorFallback({ onReset }: ErrorFallbackProps) {
  const translate = useTranslator();
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-s12 p-s24 text-center bg-background text-foreground">
      <h2 className="text-ts20 font-semibold m-0">{translate('Something went wrong')}</h2>
      <p className="text-ts14 text-foreground-tint m-0 max-w-[420px]">{translate("The AI Stylist hit an unexpected error and the page can't render. The issue has been reported. Try refreshing.")}</p>
      <button
        data-testid="error-fallback-try-again-button"
        type="button"
        onClick={onReset}
        className="py-s10 px-s24 rounded-r8 border border-primary-base bg-primary-base text-primary-text text-ts14 font-medium cursor-pointer transition-colors duration-150 hover:bg-primary-base-action"
      >
        {translate('Try again')}
      </button>
    </div>
  );
}
